import { lazyOpenAgentChatAndAddPrompt } from 'owa-bizchat-shared';
import type { AgentType } from 'owa-bizchat-shared';
import type { ChatInputRawEntityData } from '@1js/scc-types';
import type { QueryAnnotation } from '@1js/sydney-types';
import type { IContextualChat } from 'owa-bizchat-types/lib/types';

export type OpenAgentChatPaneOptions = {
    promptText: string;
    agentType?: AgentType;
    targetWindow: Window;
    shouldExecuteQuery?: boolean;
    rawEntityData?: ChatInputRawEntityData[];
    queryAnnotations?: QueryAnnotation[];
    formCode?: string;
    contextualChat?: IContextualChat;
};

/**
 * Opens the Copilot chat side pane with an agent @mentioned and the specified prompt.
 * Mirrors openChatPane but routes through openAgentChatAndAddPrompt to preserve
 * the prompt while targeting the agent.
 */
export const openAgentChatPane = ({
    promptText,
    agentType,
    targetWindow,
    shouldExecuteQuery,
    rawEntityData,
    queryAnnotations,
    formCode,
    contextualChat,
}: OpenAgentChatPaneOptions): void => {
    lazyOpenAgentChatAndAddPrompt.importAndExecute(
        'CopilotDabRibbonSUA',
        promptText,
        agentType,
        shouldExecuteQuery,
        rawEntityData,
        queryAnnotations,
        formCode,
        true /* isNewChat */,
        targetWindow,
        undefined /* openNewChatWithoutPrompt */,
        contextualChat
    );
};
